import { useEffect, useRef, useState } from "react";

import { IconButton, LinkButton } from "@client:common/button";
import { Ripple } from "@client:common/effects/ripple";
import {
  Form,
  FormControl,
  FormGroup,
  PasswordFormField,
  ShortTextFormField
} from "@client:common/form";
import { Validators } from "@client:common/form/validation";
import { Icon } from "@client:common/icon";

import "./LoginForm.dark.scss";
import "./LoginForm.light.scss";

interface Props {
  onLogin: (email: string, password: string) => void;
}

export function LoginForm(props: Props) {
  const loginFormGroupRef = useRef(
    new FormGroup({
      email: new FormControl("", [Validators.checkValidEmail()]),
      password: new FormControl("", [Validators.checkNotEmpty()])
    })
  );

  const onLogin = () => {
    const loginFormValue = loginFormGroupRef.current.getValue();
    props.onLogin(loginFormValue.email, loginFormValue.password);
  };

  const [isFormValid, setIsFormValid] = useState(
    loginFormGroupRef.current.isValid()
  );

  useEffect(() => {
    const subscription = loginFormGroupRef.current.validityChanges().subscribe({
      next: setIsFormValid
    });

    return () => {
      subscription.unsubscribe();
    };
  }, [loginFormGroupRef.current]);

  return (
    <div className="login-form-container">
      <header className="login-form-container__header">
        <h2>Log in</h2>
      </header>
      <Form
        className="login-form"
        formGroup={loginFormGroupRef.current}
        onSubmit={onLogin}
      >
        <ShortTextFormField
          label="Email"
          type="email"
          formControl={loginFormGroupRef.current.findControl("email")}
        />
        <PasswordFormField
          label="Password"
          formControl={loginFormGroupRef.current.findControl("password")}
        />
        <LinkButton
          openInNewTab
          to="/pages/account/recovery/request/password"
          className="forget-password-trigger"
          style="basic"
          color="primary"
        >
          FORGET PASSWORD?
        </LinkButton>
        <div className="action-controls_container">
          <LinkButton
            openInNewTab
            to="/pages/account/registration"
            style="basic"
            color="primary"
            className="create-account-trigger"
          >
            <Icon icon="open_in_new" />
            CREATE ACCOUNT
          </LinkButton>
          <IconButton
            className="login-form__login-trigger"
            style="raised"
            color="primary"
            disabled={!isFormValid}
            onClick={onLogin}
          >
            <Ripple /> <Icon icon="login" /> LOG IN
          </IconButton>
        </div>
      </Form>
    </div>
  );
}
